// DS2.5.2
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import IconButton from '..';
import s from './IconButtonWithBackground.scss';
const IconButtonWithBackground = (_param)=>{
    var { className , variant ='main'  } = _param, props = _object_without_properties(_param, [
        "className",
        "variant"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, /*#__PURE__*/ React.createElement(IconButton, _extends({
        variant: variant
    }, props))));
};
IconButtonWithBackground.displayName = 'IconButtonWithBackground';
export default IconButtonWithBackground;
